import { ColGroupDef } from '@ag-grid-community/core';

import {
  AgColumnGroupHeaderComponent,
  AgColumnGroupHeaderExternalParams,
} from '@shared/ag-components/ag-column-group-header/ag-column-group-header';
import { AuxExcelStyleKeys } from '@shared/utils/aux-excel-styles/aux-excel-style-keys';

import {
  qcGetInvoiceColumnDefaults,
  qcGetMoneyColumn,
  QuarterCloseGridConfigContext,
} from './qc-grid-config-context';

const localStorageKey = 'closing_page_qc_qstart';

export const qcQuarterStartColumnGroup = (
  ctx: QuarterCloseGridConfigContext,
  isFluxAnalysisAvailableAndOn: boolean
): ColGroupDef => {
  const openByDefault = localStorage.getItem(localStorageKey) === 'true';

  return {
    children: [
      {
        ...qcGetMoneyColumn(),
        columnGroupShow: 'open',
        field: `qstart_wp_ltd`,
        headerName: 'Expense LTD',
        hide: isFluxAnalysisAvailableAndOn,
      },
      {
        ...qcGetMoneyColumn(),
        ...qcGetInvoiceColumnDefaults(ctx),
        columnGroupShow: 'open',
        field: `qstart_invoiced_ltd`,
        headerName: 'Invoiced LTD',
        hide: isFluxAnalysisAvailableAndOn,
      },
      {
        ...qcGetMoneyColumn(),
        field: `qstart_accrual_ltd`,
        headerName: 'Accrual LTD',
        hide: isFluxAnalysisAvailableAndOn,
        minWidth: 125,
      },
      {
        ...qcGetMoneyColumn(),
        field: `qstart_prepaid_ltd`,
        headerName: 'Prepaid LTD',
        hide: isFluxAnalysisAvailableAndOn,
        minWidth: 125,
      },
    ],
    headerClass: ['text-center', 'header-marker', 'blue-marker', AuxExcelStyleKeys.ALTERNATE],
    headerGroupComponent: AgColumnGroupHeaderComponent,
    headerGroupComponentParams: <AgColumnGroupHeaderExternalParams>{
      onToggle: (isOpen: boolean) => {
        localStorage.setItem(localStorageKey, String(isOpen));
      },
    },
    headerName: 'Quarter Start',
    openByDefault,
  };
};
